// 文字バリデーション（3層方式）
//
// 全体適用ルール ＋ 個別ブラックリスト ＋ 個別ホワイトリスト。
// 「個別」のスコープは name（姓名・宛名）/ address（住所1・住所2・会社名）/ noshi（のし名入れ）。
// 市区町村など個別ルール対象外の欄は scope 'global'（全体ルールのみ）で判定する。
//
// 判定順（1文字ごと。明示的な拒否 ＞ 明示的な許可 ＞ 一般ルール）:
//   ① 個別ブラックリスト → NG
//   ② 個別ホワイトリスト → OK（全体ルール・組込みルールを上書き）
//   ③ 全体ルール違反（JIS X 0208外 / 絵文字 / 全体ブラックリスト） → NG
//   ④ スコープ組込みルール違反（name: 許可パターン外, noshi: 記号・約物） → NG
//   ⑤ OK
//
// 設計: docs/char-validation-design.md（§2・§7）
// 初期リスト: docs/char-validation-initial-lists.json（YM松尾さん確認済み 2026-07-15。
//             全7,041字×3欄で確定マトリクスとの判定一致を検証済み）
//
// 依存: assets/jis-x-0208-table.js（window.JIS_X_0208_CODEPOINTS_HEX）
// 設定: window.CHAR_VALIDATION_CONFIG（Liquid が Shop メタフィールド custom.validation_* から注入。
//       キー未設定時は下記 DEFAULTS を使用。リストは「対象文字を区切りなしで連結した文字列」）

(function (global) {
  'use strict';

  var OLD_KANJI = '髙﨑邉邊齊齋國濱廣櫻澤';

  // ギリシャ・キリル・半角カナは範囲から生成（列挙ミス防止）
  function buildRange(from, to, skips) {
    var s = '';
    for (var cp = from; cp <= to; cp++) {
      if (skips && skips.indexOf(cp) !== -1) continue;
      s += String.fromCodePoint(cp);
    }
    return s;
  }
  var GREEK = buildRange(0x391, 0x3A9, [0x3A2]) + buildRange(0x3B1, 0x3C9, [0x3C2]); // 48字
  var CYRILLIC = 'Ё' + buildRange(0x410, 0x44F) + 'ё';                     // 66字
  var HW_KANA = buildRange(0xFF66, 0xFF9F);                                          // 58字

  var DEFAULTS = {
    global_blacklist: '"“”|,?*#\\_%●【】\'' + GREEK + CYRILLIC + '¶',
    name_blacklist: '',
    name_whitelist: OLD_KANJI + '0123456789０１２３４５６７８９&＆@＠-‐―ヽヾ',
    address_blacklist: '★☆♪♫♬#$%^*~`|\\<>{}[]!"\'+=§©®™°¥€£¢±×÷√∞',
    address_whitelist: OLD_KANJI,
    noshi_blacklist: HW_KANA + 'ゝゞ',
    noshi_whitelist: OLD_KANJI + '&＆@＠‐―・･．'
  };

  var MSG_JIS = '使用できない文字「{char}」が含まれています。別の文字でご入力ください。';
  var MSG_CHAR = '「{char}」は使用できない文字です。別の文字でご入力ください。';

  // スコープ組込みルール（文字クラス単位の制約。列挙で表現できないためコード側に持つ）
  // name: 英字/かな/漢字/一部記号/空白のみ許可（1文字判定用に ^…$）
  var NAME_ALLOWED = /^[A-Za-zＡ-Ｚａ-ｚぁ-んァ-ヶー一-龠々〆ヵヶ・･\s　]$/;
  // noshi: Unicode の記号(S)・約物(P)・絵文字を全面ブロック（例外はホワイトリストで開ける）
  var NOSHI_BLOCKED = /[\p{Extended_Pictographic}\p{S}\p{P}]/u;
  // 全体ルール: 絵文字（サロゲートペア＋雑記号ブロック）
  var EMOJI = /[\uD83C-\uDBFF][\uDC00-\uDFFF]|[☀-➿]/;

  var _jisSet = null;      // JIS X 0208 コードポイント Set
  var _ruleCache = null;   // scope → {black:Set, white:Set}

  function buildJisSet() {
    var hex = global.JIS_X_0208_CODEPOINTS_HEX;
    if (!hex) {
      // テーブル未ロード時は JIS 判定のみスキップ（ブラックリスト等は生きる）
      console.warn('[char-validator] JIS_X_0208_CODEPOINTS_HEX is not loaded. JIS check skipped.');
      return null;
    }
    var set = new Set();
    var parts = hex.split(',');
    for (var i = 0; i < parts.length; i++) set.add(parseInt(parts[i], 16));
    return set;
  }

  function toCharSet(str) {
    var set = new Set();
    if (typeof str !== 'string') return set;
    var iter = str[Symbol.iterator]();
    var step = iter.next();
    while (!step.done) { set.add(step.value); step = iter.next(); }
    return set;
  }

  function getRules() {
    if (_ruleCache) return _ruleCache;
    var cfg = global.CHAR_VALIDATION_CONFIG || {};
    function pick(key) {
      return typeof cfg[key] === 'string' && cfg[key].length > 0 ? cfg[key] : DEFAULTS[key];
    }
    _ruleCache = {
      globalBlack: toCharSet(pick('global_blacklist')),
      name:    { black: toCharSet(pick('name_blacklist')),    white: toCharSet(pick('name_whitelist')) },
      address: { black: toCharSet(pick('address_blacklist')), white: toCharSet(pick('address_whitelist')) },
      noshi:   { black: toCharSet(pick('noshi_blacklist')),   white: toCharSet(pick('noshi_whitelist')) },
      global:  { black: new Set(), white: new Set() }
    };
    return _ruleCache;
  }

  function getJisSet() {
    if (_jisSet === null) _jisSet = buildJisSet();
    return _jisSet;
  }

  /**
   * 1文字を判定する。
   * @returns {string|null} NG理由 'jis'|'blocked'。OKなら null。
   */
  function judgeChar(ch, scope) {
    var rules = getRules();
    var scopeRules = rules[scope] || rules.global;
    if (scopeRules.black.has(ch)) return 'blocked';              // ① 個別ブラックリスト
    if (scopeRules.white.has(ch)) return null;                   // ② 個別ホワイトリスト
    var jis = getJisSet();
    if (jis && !jis.has(ch.codePointAt(0))) return 'jis';        // ③ JIS X 0208外
    if (EMOJI.test(ch)) return 'blocked';                        // ③ 絵文字
    if (rules.globalBlack.has(ch)) return 'blocked';             // ③ 全体ブラックリスト
    if (scope === 'name' && !NAME_ALLOWED.test(ch)) return 'blocked';   // ④ 組込み
    if (scope === 'noshi' && NOSHI_BLOCKED.test(ch)) return 'blocked';  // ④ 組込み
    return null;                                                 // ⑤ OK
  }

  /**
   * 文字列中の最初の NG 文字を返す。
   * @param {string} str
   * @param {string} scope 'name' | 'address' | 'noshi' | 'global'
   * @returns {{char: string, reason: string}|null}
   */
  function findInvalid(str, scope) {
    if (!str) return null;
    var iter = str[Symbol.iterator]();
    var step = iter.next();
    while (!step.done) {
      var reason = judgeChar(step.value, scope);
      if (reason) return { char: step.value, reason: reason };
      step = iter.next();
    }
    return null;
  }

  /**
   * NG 文字があればエラーメッセージを返す。なければ null。
   */
  function validate(str, scope) {
    var bad = findInvalid(str, scope);
    if (!bad) return null;
    var tpl = bad.reason === 'jis' ? MSG_JIS : MSG_CHAR;
    return tpl.replace('{char}', bad.char);
  }

  global.CharValidator = {
    findInvalid: findInvalid,
    validate: validate,
    judgeChar: judgeChar,
    /** テスト用: 設定キャッシュを破棄して再読込させる */
    _resetCache: function () { _ruleCache = null; _jisSet = null; }
  };
})(typeof window !== 'undefined' ? window : globalThis);
